import { render, staticRenderFns } from "./EditPermitInvitation.vue?vue&type=template&id=59150b86"
import script from "./EditPermitInvitation.vue?vue&type=script&lang=js"
export * from "./EditPermitInvitation.vue?vue&type=script&lang=js"
import style0 from "./EditPermitInvitation.vue?vue&type=style&index=0&id=59150b86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports